export default __webpack_public_path__ + "static/media/greeter.af0b6bf2.svg";